import styles from './Button.module.css';
import type { ButtonVariant } from './Button.tsx';

/** Shared class names so router links can look like buttons without a second system. */
export function buttonClass(
  variant: ButtonVariant = 'secondary',
  size: 'default' | 'small' = 'default',
) {
  return [styles.button, styles[variant], styles[size]].join(' ');
}
